import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Row, Col, FormGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import Loader from "../components/Loader";
import FormContainer from "../components/FormContainer";
import PasswordChecker from "../components/PasswordChecker";
import { registerUser } from "../actions/userActions";
import ReCAPTCHA from "react-google-recaptcha";
import { callRecaptcha } from "../actions/recaptchaActions";
import prefixes from "../data/prefixes";
import EmailCell from "../components/EmailCell";
import Meta from "../components/Meta";
import { FaSignInAlt } from "react-icons/fa";
import { generatePassword } from "../components/passwordGenerator";
import { InputGroup } from "react-bootstrap";
import { MdHelpOutline, MdVisibility, MdVisibilityOff } from "react-icons/md";
import { notify } from "../components/notify";

const UserRegister = () => {
  const [prefixId, setPrefixId] = useState("1");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const genPassword = generatePassword(10);
  const [password, setPassword] = useState(genPassword);
  const [confirmPassword, setConfirmPassword] = useState(genPassword);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [message, setMessage] = useState(null);
  const [emailError, setEmailError] = useState("");

  const dispatch = useDispatch();
  const captchaRef = useRef(null);

  const registeredUser = useSelector((state) => state.registeredUser);
  const { loading, error } = registeredUser;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const recaptchaConstantStore = useSelector(
    (state) => state.recaptchaConstantStore,
  );
  const { siteKey } = recaptchaConstantStore;

  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo) {
      navigate("/clinic-list-screen");
    }
    if (!siteKey) {
      dispatch(callRecaptcha());
    }
  }, [userInfo, siteKey]);

  const submitHandler = (e) => {
    e.preventDefault();
    // if (!captchaRef.current) {
    //   notify({
    //     title: "Recaptcha Err",
    //     message: (
    //       <p className="lead">
    //         Kindly, check the reCAPTCHA box first.
    //         <br />
    //         It takes a few seconds to load below 👇👇
    //       </p>
    //     ),
    //     type: "danger",
    //     duration: 4000,
    //   });
    //   return;
    // }
    // const token = captchaRef.current.getValue();
    setMessage("");

    if (password && password === confirmPassword) {
      dispatch(
        registerUser({
          prefixId,
          firstName,
          lastName,
          email: email.toLowerCase(),
          phone,
          password,
          // token,
        }),
      );
    }

    if (!password) {
      setMessage("Password is required");
    }
    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
    }
  };

  return (
    <>
      <Meta title={`Register Screen`} />
      <FormContainer>
        <Row>
          <Col>
            <h2>Sign Up </h2>
          </Col>
          <Col className="align-self-center">
            <h2>
              {`Have an Account? `}
              <span
                className="link text-success"
                onClick={() => {
                  navigate("/login-screen");
                }}
              >
                <FaSignInAlt /> login
              </span>
            </h2>
          </Col>
        </Row>

        <Row className="d-flex justify-content-end mb-3"></Row>
        <Form onSubmit={submitHandler} className="form-row ">
          <Form.Group controlId="prefixId" className="col-sm-2">
            <Form.Label>Prefix</Form.Label>
            <select
              className="custom-select"
              type="name"
              value={prefixId}
              onChange={(e) => setPrefixId(e.target.value)}
            >
              {prefixes.map((p) => (
                <option key={p._id} value={p._id} disabled={p.disabled}>
                  {p.name}
                </option>
              ))}
            </select>
          </Form.Group>

          <Form.Group controlId="firstName" className="col-sm-5">
            <Form.Label>First Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              isValid={firstName}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId="lastName" className="col-sm-5">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              isValid={lastName}
            ></Form.Control>
          </Form.Group>

          <Form.Label>Email</Form.Label>
          <div className="w-100">
            <EmailCell
              email={email}
              setEmail={setEmail}
              emailError={emailError}
              setEmailError={setEmailError}
            />
          </div>

          <Form.Group controlId="phone" className="col-sm-12">
            <Form.Label>Whatsapp Phone </Form.Label>
            <Form.Control
              placeholder="Enter Phone (Whatsapp)"
              type="phone"
              onChange={(e) => setPhone(e.target.value)}
              value={phone}
              isValid={phone}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId="password" className="col-sm-12">
            <Form.Label>Password</Form.Label>

            <InputGroup>
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                isValid={password}
              />

              <InputGroup.Text
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <MdVisibilityOff size={20} />
                ) : (
                  <MdVisibility size={20} />
                )}
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>

          <PasswordChecker password={password} />

          <Form.Group controlId="confirmPassword" className="col-sm-12">
            <Form.Label>Confirm Password</Form.Label>

            <InputGroup>
              <Form.Control
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Enter password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                isValid={confirmPassword}
              />

              <InputGroup.Text
                style={{ cursor: "pointer" }}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? (
                  <MdVisibilityOff size={20} />
                ) : (
                  <MdVisibility size={20} />
                )}
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>
          {/* <FormGroup className="col-sm-12">
            {siteKey ? (
              <ReCAPTCHA sitekey={siteKey} ref={captchaRef} />
            ) : (
              "please wait seconds for the reCAPTCHA to load"
            )}
          </FormGroup> */}

          {error && (
            <Message variant="danger" children={`Register Err:${error}`} />
          )}
          {message && <Message variant="danger">{message}</Message>}
          <Row>
            {loading ? (
              <Loader />
            ) : (
              <FormGroup className="d-flex justify-content-end">
                <Button type="submit" variant="primary">
                  Create Account
                </Button>
              </FormGroup>
            )}
          </Row>
        </Form>
        <Row className="py-3">
          <Col>
            Already have account?{" "}
            <span
              className="link text-success"
              onClick={() => {
                navigate("/login-screen");
              }}
            >
              Go to login screen
            </span>
          </Col>
        </Row>
      </FormContainer>
    </>
  );
};

export default UserRegister;
